export enum TokenVaultVerification {
  SMS = 'sms',
  EMAIL = 'email',
}
